import { render, staticRenderFns } from "./EncounterReviewSystemTable.vue?vue&type=template&id=17076175&"
import script from "./EncounterReviewSystemTable.vue?vue&type=script&lang=js&"
export * from "./EncounterReviewSystemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports